import React from "react";
import { Instagram } from "lucide-react";
import { useSettings } from "../context/SettingsContext";
import { imgUrl } from "../lib/api";

const About = () => {
  const { settings } = useSettings();
  return (
    <div className="px-6 md:px-12 lg:px-20 py-20 md:py-32" data-testid="page-about">
      <div className="grid md:grid-cols-12 gap-12 md:gap-20">
        <div className="md:col-span-5">
          {settings.about_image_url && (
            <img
              src={imgUrl(settings.about_image_url)}
              alt="Jewel in her studio"
              className="w-full aspect-[4/5] object-cover"
              data-testid="about-portrait"
            />
          )}
        </div>
        <div className="md:col-span-7">
          <div className="label-eyebrow mb-4">About the Artist</div>
          <h1 className="font-serif-display text-5xl md:text-6xl text-[#1A1F1B] leading-[1]">
            Hello, I&apos;m{" "}
            <em className="italic text-[#3B4A3F]" data-testid="about-name">
              {settings.about_intro_name || "Jewel"}
            </em>
            .
          </h1>
          <div className="mt-8 space-y-6 text-[#4E5C50] text-base md:text-lg leading-relaxed max-w-2xl">
            {(settings.about_paragraphs || []).map((p, i) => (
              <p key={i} data-testid={`about-paragraph-${i}`}>
                {p}
              </p>
            ))}
            {settings.contact_instagram && (
              <p>
                I share work-in-progress and studio glimpses on Instagram at{" "}
                <a
                  href={`https://instagram.com/${settings.contact_instagram}`}
                  className="underline underline-offset-4 text-[#3B4A3F] hover:text-[#A39171]"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="about-instagram-link"
                >
                  @{settings.contact_instagram}
                </a>
                .
              </p>
            )}
          </div>

          <div className="mt-12 grid grid-cols-2 gap-8 max-w-md">
            <div>
              <div className="label-eyebrow">Based in</div>
              <div className="font-serif-display text-xl text-[#1A1F1B] mt-1" data-testid="about-based-in">
                {settings.about_based_in}
              </div>
            </div>
            <div>
              <div className="label-eyebrow">Working in</div>
              <div className="font-serif-display text-xl text-[#1A1F1B] mt-1" data-testid="about-working-in">
                {settings.about_working_in}
              </div>
            </div>
          </div>

          {settings.contact_instagram && (
            <a
              href={`https://instagram.com/${settings.contact_instagram}`}
              target="_blank"
              rel="noreferrer"
              className="btn-secondary mt-12 inline-flex items-center gap-2"
              data-testid="about-follow-button"
            >
              <Instagram size={16} /> Follow the Studio
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default About;
